const Footer = () => {
  return (
    <footer className="w-full px-4 text-center py-3 text-black text-xs sm:text-sm mt-auto theme-footer">
      <p className="m-0 tracking-wide">
        Designed and Developed By: {" "}
        <span className="font-semibold text-blue-700">VRSamadhan Tech Solution</span>
      </p>
    </footer>
  );
};

export default Footer;
